import { getInviteData } from './../../services/inviteService';

export const getInviteDataRedux = () => {
    return async(dispatch, getState) => {
        const { data } = await getInviteData()
        // console.log(data);
        await dispatch({ type: 'SET_INVITE_DATA', payload: {...data.data } })
    }
}